import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import { useTranslation } from "react-i18next";

import { useUpdateNotificationHandlerNotificationHandlersIdPatchMutation } from "api";
import { INotificationHandler } from "interfaces/notification.interface";

type ToggleHandlerDialogProps = {
  handler?: INotificationHandler;
  onClose: () => void;
};

export function ToggleHandlerDialog({
  handler,
  onClose,
}: ToggleHandlerDialogProps) {
  const { t } = useTranslation();

  const [updateHandler] =
    useUpdateNotificationHandlerNotificationHandlersIdPatchMutation();

  return (
    <Dialog open={!!handler} onClose={onClose}>
      <DialogTitle>
        {handler?.enabled
          ? t("disable_notification_handler")
          : t("enable_notification_handler")}
      </DialogTitle>
      <DialogContent dividers>
        {handler?.enabled
          ? `${t("are_you_sure_you_want_to_disable_this_notification_handler")}`
          : `${t("are_you_sure_you_want_to_enable_this_notification_handler")}`}
      </DialogContent>
      <DialogActions>
        <Button variant={"text"} onClick={onClose}>
          {t("Cancel")}
        </Button>
        <Button
          color={handler?.enabled ? "warning" : "primary"}
          onClick={async () => {
            if (handler) {
              await updateHandler({
                id: handler.id,
                notificationHandlerUpdateModels: {
                  type: handler.type,
                  enabled: !handler.enabled,
                },
              });
            }

            onClose();
          }}
        >
          {handler?.enabled ? t("Yes_disable_it") : t("Yes_enable_it")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
